import {
    apiRequest,
    skcpnsApprove
} from '../../../../../services/adapters/kepegawaian/skcpnsService'

class UpdateRepository {

    fetchApprove = async (query) => {
        return await apiRequest("post", skcpnsApprove, {
            body: query
        }, true)
    }

}

export default UpdateRepository